export default __webpack_public_path__ + "static/media/collage-mentorias.eaecbce7.png";